<template>
  <div class="table-container" v-if="canVerb(resource, 'index')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span @click="resetSingleSidebarFilter(name)" title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
      <export-options
        :exportUrl="exportUrl"
        :repository="repository"
        :resource="resource"
        :tableRef="$refs[tableRef]"
        :filter="filter"
        :options="[
          {
            code: 'EXCOFOCA',
            label: null,
            formats: ['csv', 'pdf'],
          },
        ]"
      ></export-options>
    </actions-toolbar>

    <b-sidebar
      id="sidebar-1"
      :title="computedFilterTitle"
      :backdrop="true"
      width="50dvw"
      shadow
      right
      :visible="open_filter"
      :data-open="open_filter"
      @change="onSidebarFilterChange"
    >
      <b-form @submit.prevent="onSearch(filterName)">
        <div class="filter">
          <div class="filter-item">
            <base-datepicker
              name="a_partire_dal"
              label="Data"
              v-model="filter.a_partire_dal"
            />
          </div>
        </div>
        <div class="actions-filter-sidebar-wrapper">
          <b-button
            type="submit"
            variant="lisaweb"
            size="sm"
            v-b-toggle:sidebar-1
            >Cerca
          </b-button>
          <b-button
            class="btn--transparent btn-reset"
            type="button"
            size="sm"
            @click="onClearFilter(filterName)"
            >Reset
          </b-button>
        </div>
      </b-form>
    </b-sidebar>

    <exp-cash-entries-table
      :fields="fields"
      :repository="repository"
      :resource="resource"
      :filterName="filterName"
      @manualFetch="manualFetch"
      :performedSearch="computePerformedSearch"
      :filterCount="countActiveFilters"
      :filterOn="{
        byRelations: ['byBroker', 'byTreasury', 'byCashReference'],
      }"
      :ref="tableRef"
      :previous_balance_date="previous_balance_date"
      :previous_balance="previous_balance"
      :current_balance_date="filter.fino_al"
      :current_balance="current_balance"
      type="exp-cash-entry"
      noActions
      noPagination
    ></exp-cash-entries-table>

    <p style="margin-left: 15px; margin-top: 40px; text-transform: uppercase">
      <strong>Controllo Saldo Conto per Compagnie</strong>
    </p>

    <!-- <saldo-conto-compagnie-foglio-cassa
      :fields="fieldsComparison"
      :items="itemsComparison"
      :repository="repository"
      :resource="resource"
      :ref="tableRefComparison"
      noActions
      noPagination
    ></saldo-conto-compagnie-foglio-cassa> -->
    <b-table
      :fields="fieldsComparison"
      :items="itemsComparison"
      :repository="repository"
      :resource="resource"
      :ref="tableRefComparison"
      noActions
      noPagination
      :busy="isLoadingComparison"
      head-variant="light"
      :current-page="1"
      per-page="0"
      :sticky-header="true"
      no-border-collapse
      responsive
      show-empty
      empty-text="Non ci sono informazioni da mostrare"
      small
    >
      <template #table-busy>
        <table-skeleton />
      </template>
      <template #empty>
        <empty-table
          :performedSearch="performedSearch"
          :filterCount="countActiveFilters"
        />
      </template>
      <template #cell(actions)="row">
        <div class="action-buttons" :data-match="!checkSaldiMatch(row.item)">
          <b-button
            v-if="!checkSaldoRegistrato(row.item)"
            size="sm"
            variant="lisaweb"
            class="mt-1 mr-1"
            style="margin-top: 0 !important; margin-right: 8px !important"
            :title="
              !checkSaldiMatch(row.item)
                ? 'Registra'
                : 'Non è possibile procedere con la registrazione in quanto i saldi differiscono.'
            "
            @click="registra(row.item)"
            :disabled="checkSaldiMatch(row.item)"
          >
            <b-icon icon="cash-stack"></b-icon>
          </b-button>
          <div
            v-if="checkSaldoRegistrato(row.item)"
            style="display: flex; align-items: center"
          >
            <b-icon
              icon="check-circle-fill"
              variant="success"
              font-scale="2"
              title="Registrato con successo"
            ></b-icon>
          </div>
          <div
            v-if="checkSaldoRegistrato(row.item) && checkErrors(row.item)"
            style="display: flex; align-items: center; margin-left: 5px"
          >
            <b-icon
              icon="exclamation-triangle-fill"
              variant="danger"
              font-scale="2"
              title="Attenzione, dopo la registrazione dei totalizzatori alcuni valori sono cambiati"
            ></b-icon>
          </div>
        </div>
      </template>
      <template #cell(check_saldi)="row">
        <span class="equal" v-if="checkSaldi(row.item)">&equals;</span>
        <span class="not-equal" v-else>&ne;</span>
      </template>
    </b-table>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
// import CashEntriesTable from "@/components/tables/CashEntry.vue";
import ExpCashEntriesTable from "@/components/tables/ExpCashEntry.vue";
// import SaldoContoCompagnieFoglioCassa from "@/components/tables/SaldoContoCompagnieFoglioCassa.vue";
// import BaseSelect from "@/components/form/BaseSelect";
import BaseIcon from "@/components/BaseIcon";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import { mapActions, mapGetters } from "vuex";
import { toLocaleDate } from "@/utils/dates";
import { toLocaleCurrency } from "@/utils/strings";
import { today } from "@/utils/dates";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";
// import ExportOptions from "@/components/ExportOptions";
import moment from "moment";
import SidebarFilterMixin from "../../../../mixins/SidebarFilterMixin";
import ExportOptions from "../../../ExportOptions.vue";
import EmptyTable from "@/components/EmptyTable.vue";

moment.locale("it");
export default {
  mixins: [CustomFiltersMixin, StorageGetterMixin, SidebarFilterMixin],
  data() {
    return {
      exportUrl: null,
      repository: "cash_entry",
      resource: "movimenti_prima_nota",
      tableRef: "CashEntriesExportTableRef",
      tableRefComparison: "SaldoContoCompagnieFoglioCassaTableRef",
      filterName: "filterControlloFoglioCassa",
      cash_references_opt: [],
      treasuries_opt: [],
      companies: [],
      contoPrimaNota: "PNC",
      causaleRegistrazione: "TFC",
      registrazioniRegistrate: [],
      idCausalePrimaNota: "",
      cashEntryType: "",
      performedSearch: false,
      activeFilters: {},
      filter: this.initFilter(),
      previous_balance_date: null,
      previous_balance: {},
      current_balance: {},
      fields: [
        {
          key: "conto.codice",
          label: this.getDictionary("Conto"),
        },
        {
          key: "data_registrazione",
          formatter: (value) => toLocaleDate(value),
          label: this.getDictionary("cash_time", "cash_entry"),
        },
        {
          key: "produttore.title",
          label: this.getDictionary("salesman"),
        },
        {
          key: "causale",
          label: this.getDictionary("cash_reference_id", "cash_entry"),
          formatter: (value) => `${value.codice} - ${value.descrizione}`,
        },
        {
          key: "descrizione",
          label: this.getDictionary("title", "cash_entry"),
        },
        {
          key: "id_compagnia",
          label: "Compagnia",
          formatter: (value) => this.retriveInsurer(value),
        },
        {
          key: "entrate",
          formatter: (value, field, item) => {
            if (item?.causale?.tipo_di_movimento === 0)
              return toLocaleCurrency(Math.abs(parseFloat(item.importo)));
            return toLocaleCurrency(0);
          },
          label: this.getDictionary("entry_in", "cash_entry"),
          tdClass: "text-right",
          thStyle: {
            "text-align": "right",
            width: "130px",
          },
        },
        {
          key: "uscite",
          formatter: (value, field, item) => {
            if (item?.causale?.tipo_di_movimento === 1)
              return toLocaleCurrency(Math.abs(parseFloat(item.importo)));
            return toLocaleCurrency(0);
          },
          label: this.getDictionary("entry_out", "cash_entry"),
          tdClass: "text-right",
          thStyle: {
            "text-align": "right",
            width: "130px",
          },
        },
      ],
      fieldsComparison: [
        {
          key: "actions",
          label: "",
        },
        {
          key: "id_compagnia",
          label: "Compagnia",
          formatter: (value) => this.retriveInsurer(value),
        },
        {
          key: "entrate",
          formatter: (value) => toLocaleCurrency(value),
          label: this.getDictionary("entry_in", "cash_entry"),
          tdClass: "text-right",
          thStyle: {
            "text-align": "right",
            width: "130px",
          },
        },
        {
          key: "uscite",
          formatter: (value) => toLocaleCurrency(value),
          label: this.getDictionary("entry_out", "cash_entry"),
          tdClass: "text-right",
          thStyle: {
            "text-align": "right",
            width: "130px",
          },
        },
        {
          key: "saldo_contabilita",
          formatter: (value) => toLocaleCurrency(value),
          label: this.getDictionary("saldo_contabilita", "cash_entry"),
          tdClass: "text-right",
          thStyle: {
            "text-align": "right",
            width: "130px",
          },
        },
        {
          key: "check_saldi",
          label: "",
          tdClass: "text-center",
          thStyle: {
            "text-align": "center",
            width: "80px",
          },
        },
        {
          key: "saldo_foglio_cassa",
          formatter: (value) => toLocaleCurrency(value),
          label: this.getDictionary("saldo_foglio_cassa", "cash_entry"),
          tdClass: "text-right",
          thStyle: {
            "text-align": "right",
            width: "125px",
          },
        },
      ],
      itemsComparison: [],
      isLoadingComparison: false,
    };
  },
  components: {
    // CashEntriesTable,
    ExpCashEntriesTable,
    // SaldoContoCompagnieFoglioCassa,
    // BaseSelect,
    ExportOptions,
    BaseIcon,
    BaseDatepicker,
    EmptyTable,
    // ExportOptions,
  },
  computed: {
    countActiveFilters() {
      console.log("COUNT ACT FILTERS", Object.keys(this.activeFilters));
      return Object.keys(this.activeFilters).length;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
  },
  methods: {
    manualFetch() {
      this.resetAllFilters();
    },
    resetAllFilters() {
      this.onClearFilter(this.filterName);
      this.activeFilters = {};
      this.itemsComparison = [];
      this.registrazioniRegistrate = [];
      this.previous_balance_date = null;
      this.previous_balance = {};
      this.current_balance = {};
      const table = this.tableRef ? this.$refs[this.tableRef] : null;
      if (table) {
        table.items = [];
        table.totalRows = 0;
      }
      this.open_filter = true;
    },
    registra(item) {
      console.log("registra");
      const Repo = RepositoryFactory.get(this.repository);
      let payload = {
        cash_entry_type: this.cashEntryType,
        data_registrazione: this.filter.a_partire_dal,
        id_causale_prima_nota: this.idCausalePrimaNota,
        id_compagnia: item.id_compagnia,
        id_conto_prima_nota: this.filter.conto,
        importo: item.saldo_contabilita,
      };
      Repo.store(payload)
        .then((response) => {
          console.log("response", response);
          // this.$refs[this.tableRef].isLoading = true;
          // this.$refs[this.tableRefComparison].isLoading = true;
          // this.isLoadingComparison = true;
          this.onSearch(this.filterName);
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    checkErrors(item) {
      // return item?.saldo_foglio_cassa !== 0 || item?.saldo_foglio_cassa !== this.registrazioniRegistrate[item.id_compagnia].saldo_contabilita;
      const saldo_contabilita = this.registrazioniRegistrate.find(
        (el) => el?.id_compagnia === item?.id_compagnia,
      )?.saldo_contabilita;
      return (
        Number(item?.saldo_contabilita) !== 0 ||
        Number(item?.saldo_foglio_cassa) !== Number(saldo_contabilita)
      );
    },
    checkSaldi(item) {
      return item.saldo_contabilita === item.saldo_foglio_cassa;
    },
    checkSaldiMatch(item) {
      return this.checkSaldi(item) ? this.checkSaldoRegistrato(item) : true;
    },
    checkSaldoRegistrato(item) {
      return item?.match && item?.match === 1 ? true : false;
    },
    retriveInsurer(value) {
      let insurer_text = "";
      this.companies.forEach((company) => {
        if (company.value === value) insurer_text = company.text;
      });
      return insurer_text;
    },
    initFilter() {
      let init = {
        a_partire_dal: today(),
        fino_al: today(),
        produttore: null,
        causale: null,
        conto: null,
        compagnia: [],
        foglio_cassa_compagnia: 1,
      };
      return init;
    },
    // customFilterName(key, prefix = "byAttribute") {
    //   return `${prefix}.${key}`;
    // },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName,
      );
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      // this.$refs[this.tableRef].sortBy = "data_registrazione";
      // this.$refs[this.tableRef].sortAsc = true;
      this.fetch();
      /* Qua accodargli la nuova chiamata di this.$refs[this.tableRefComparison]
         e quindi associargli i giusti item */
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      delete this.activeFilters["conto"];
      delete this.activeFilters["foglio_cassa_compagnia"];

      return this.activeFilters;
    },
    fetch(name) {
      if (this.filter.a_partire_dal && this.filter.conto) {
        this.filter.fino_al = this.filter.a_partire_dal;
        let criteria = this.filter;
        this.saveFilterByName({ name, criteria });
        this.removePaginationByName(name);
        return this.$refs[this.tableRef]
          .fetch({ verb: { name: "listaMovimenti", alias: "index" } })
          .then(() => {
            /* Qua mantenere tutto uguale come di la - revertare le modifiche */
            this.fetchSummary()
              .then((response) => {
                /* Fare la chiamata alla index per vedere se c'è il risultato o meno */
                console.log("response", response);
                const summary_by_insurers = response?.data;
                const Repo = RepositoryFactory.get(this.repository);
                const byBroker = this.filter.produttore
                  ? `&produttore=${this.filter.produttore}`
                  : "";
                // const byCashReference = this.idCausalePrimaNota
                //   ? `&causale=${this.idCausalePrimaNota}`
                //   : "";
                const queryString = `data_registrazione_inizio=${this.filter.a_partire_dal}&data_registrazione_fine=${this.filter.fino_al}&conto=${this.filter.conto}${byBroker}`;
                Repo.index(queryString)
                  .then((response) => {
                    console.log("summary_by_insurers", summary_by_insurers);
                    console.log("response", response);
                    let data = response?.data?.data;
                    data = data.filter(
                      (item) =>
                        item.causale &&
                        item.causale.codice === this.causaleRegistrazione,
                    );
                    if (data?.length) {
                      this.registrazioniRegistrate = Object.values(
                        data.reduce((acc, item) => {
                          const compagniaId = item?.compagnia?.id;
                          if (compagniaId == null) return acc;
                          if (!acc[compagniaId]) {
                            acc[compagniaId] = {
                              compagnia_id: compagniaId,
                              importo: 0,
                            };
                          }
                          acc[compagniaId].importo += parseFloat(
                            item.importo || 0,
                          );
                          return acc;
                        }, {}),
                      ).map((x) => ({
                        id_compagnia: x.compagnia_id,
                        saldo_contabilita: x.importo.toFixed(2), // keep it string-like with 2 decimals
                      }));
                      console.log("flattened", this.registrazioniRegistrate);
                      const idsWithMatch = new Set(
                        this.registrazioniRegistrate.map((i) => i.id_compagnia),
                      ); // create a Set of ids of companies
                      this.itemsComparison = this.itemsComparison.map((item) =>
                        idsWithMatch.has(item.id_compagnia)
                          ? { ...item, match: 1 }
                          : item,
                      );
                    }
                    /* Andare a modificare gli itemsComparison */
                  })
                  .catch((error) => {
                    let errMsg = this.$getErrorMessage(error);
                    this.$showSnackbar({
                      preset: "error",
                      text: `${errMsg}`,
                    });
                  })
                  .finally(() => {
                    this.$refs[this.tableRef].isLoading = false;
                    this.$refs[this.tableRefComparison].isLoading = false;
                    this.isLoadingComparison = false;
                  });
              })
              .catch((error) => {
                let errMsg = this.$getErrorMessage(error);
                this.$showSnackbar({
                  preset: "error",
                  text: `${errMsg}`,
                });
                this.$refs[this.tableRef].isLoading = false;
                this.$refs[this.tableRefComparison].isLoading = false;
                this.isLoadingComparison = false;
              });
          });
      } else {
        if (!this.filter.conto) {
          this.$showSnackbar({
            preset: "error",
            text: `Attenzione: non risulta alcun conto collegato`,
          });
        } else {
          this.$showSnackbar({
            preset: "success",
            text: `Devi impostare una data`,
          });
        }
      }
    },
    fetchSummary() {
      this.$refs[this.tableRef].isLoading = true;
      this.$refs[this.tableRefComparison].isLoading = true;
      this.isLoadingComparison = true;
      const Repo = RepositoryFactory.get(this.repository);
      // Previous Balance
      this.previous_balance_date = moment(this.filter.a_partire_dal)
        .subtract(1, "d")
        .format("YYYY-MM-DD");
      const byBroker = this.filter.produttore
        ? `&produttore=${this.filter.produttore}`
        : "";
      const byCashReference = this.filter.causale
        ? `&causale=${this.filter.causale}`
        : "";
      // const queryString = `fino_al=${this.previous_balance_date}&conto=${this.filter.conto}${byBroker}${byCashReference}`;
      /* Non è più la saldo_conto ma saldo_conto_compagnie */
      // Repo.summaryByInsurers(queryString)
      // .then((response) => {
      // this.previous_balance = response.data;
      // Current Balance
      const queryString = `a_partire_dal=${this.filter.a_partire_dal}&fino_al=${this.filter.fino_al}&conto=${this.filter.conto}${byBroker}${byCashReference}`;
      return Repo.summaryByInsurers(queryString)
        .then((response) => {
          this.itemsComparison = response?.data;
          // this.$refs[this.tableRef].isLoading = false;
          // this.$refs[this.tableRefComparison].isLoading = false;
          // this.isLoadingComparison = false;
          return response;
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.$refs[this.tableRef].isLoading = false;
          this.$refs[this.tableRefComparison].isLoading = false;
          this.isLoadingComparison = false;
        });
      // })
      // .catch((error) => {
      //   let errMsg = this.$getErrorMessage(error);
      //   this.$showSnackbar({
      //     preset: "error",
      //     text: `${errMsg}`,
      //   });
      //   this.$refs[this.tableRef].isLoading = false;
      // });
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapGetters("auth", {
      getSalesmen: "salesmen",
      getInsurers: "insurers",
      getCashReferences: "cash_references",
      getContiPrimaNota: "allContiPrimaNota",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
  },
  created() {
    /* */
    const path = "auth/";
    const resources = [];
    if (!this.hasLoadedResource("insurers")) {
      resources.push(
        this.$store
          .dispatch(`${path}insurers`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    } else {
      this.companies = this.getInsurers();
    }
    if (resources.length) {
      this.getResources(resources)
        .then(() => {
          this.companies = this.getInsurers();
        })
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
    }
    /* */
    let cashReferences = this.getCashReferences();
    const found_causale = cashReferences.find(
      (el) => el.text === this.causaleRegistrazione,
    );
    if (
      found_causale &&
      found_causale?.value != null &&
      found_causale?.entry_type != null
    ) {
      this.idCausalePrimaNota = found_causale.value;
      this.cashEntryType = found_causale.entry_type == 1 ? "Uscita" : "Entrata";
    }
    cashReferences.sort((a, b) => a.text - b.text);
    cashReferences.forEach((el) => {
      this.cash_references_opt.push({
        text: `${el.text} - ${el.description}`,
        reference_type: el.reference_type,
        has_broker: el.has_broker,
        has_company: el.has_company,
        entry_type: el.entry_type,
        value: el.value,
        treasury_id: el.treasury_id,
      });
    });
    /* */
    this.treasuries_opt = this.getContiPrimaNota();
    this.filter.conto = this.treasuries_opt.find(
      (treasury) => treasury.code === this.contoPrimaNota,
    )?.value;
  },
  beforeMount() {
    this.removeFilterByName(this.filterName);
  },
};
</script>
<style lang="css">
.equal,
.not-equal {
  display: block;
  text-indent: 20px;
  font-size: var(--font-size-xl);
  font-weight: bold;
}

.equal {
  color: limegreen;
}

.not-equal {
  color: red;
}

tr:has(.bi-check-circle-fill):not(:has(.bi-exclamation-triangle-fill)) .equal,
tr:has(.bi-check-circle-fill):not(:has(.bi-exclamation-triangle-fill))
  .not-equal {
  display: none;
}
</style>
